import React from 'react'

function ImportedData() {
  return <div>ImportedData</div>
}

export default ImportedData
